import React from 'react';
import { Popover, OverlayTrigger } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';




const AddNewButton = (props) => {

    const popover1 = (
        <Popover id="popover-basic">
            <Popover.Content>
                {props.text}
          </Popover.Content>
        </Popover>
    )

    return (
        <OverlayTrigger trigger="hover" placement="top" overlay={popover1}>
            <FontAwesomeIcon icon='plus-square' onMouseDown={props.function} />
        </OverlayTrigger>
    )
}

export default AddNewButton